/**
 * @generated SignedSource<<81a555fed1c7de6126c4d12eb309cea8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_user" | "PdpSharedSidebarBuyerIncentives_user">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_user";
};
export type PdpRespSidebarBlurbs_user$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f82ea5f1e612f6d5a031a0e85dc398b5";

export default node;
